import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ACTION_ID } from 'src/app/common/constants';
import { GlobalConstants } from 'src/app/common/global';
import { ModalNames } from 'src/app/common/modal.config';
import { Services } from "src/app/services/api.service"
import { ModalService } from 'src/app/services/modal.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-hero-event',
  templateUrl:  `./${environment.pageFolder}/hero-event.${environment.pageFolder}.component.html`,
  styleUrls:  [`./${environment.pageFolder}/hero-event.${environment.pageFolder}.component.sass`],
  providers: [ Services ],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})

export class HeroEventComponent implements OnInit {
  @Input() allEvents: any;
  @Input() event: any;
  @Input() selectedEvent: any;
  @Input() currentOrderEventId: any | null = null;
  countDownTillEvent: string = "";
  //nextEvent: Event | undefined;
  nextEvent: any;
  showSeasonTicketHero: boolean = false;
  showMembershipHero: boolean = false;
  seasonticketUrl: any;
  showNoEventHero: boolean = false;
  showEventName!: boolean;
  normalAction = ACTION_ID.NORMAL.toString();
  subscriberAction = ACTION_ID.SUBSCRIBER_TICKET.toString();
  subscriberReservationAction = ACTION_ID.SUBSCRIBER_TICKET_OS.toString();
  seasonExclusiveAction = ACTION_ID.EXCLUSIVE_SUBSCRIBER_TICKET.toString();
  page = environment.page;

  @Output() selectedEventEmit = new EventEmitter<number>();

  constructor(
    public Services: Services,
    private Router: Router,
    private modalService: ModalService
  ) {
  }

  ngOnInit(): void {
    this.allEvents && (this.allEvents = this.allEvents.filter((item: any) => (item.team1Name || item.isGroup) && item.isVisible !== false));

    if(this.selectedEvent && !this.selectedEvent.isGroup) {
      this.nextEvent = this.selectedEvent;
      this.nextEvent!.startTime && this.countDownTimer(this.nextEvent!.startTime);
    } else if(this.selectedEvent && this.selectedEvent.isGroup) {
      this.showSeasonTicketHero = true;
    } else if(this.allEvents[0]) {
      this.nextEvent = this.allEvents[0];
      this.nextEvent!.startTime && this.countDownTimer(this.nextEvent!.startTime);
    } else {
      this.showMembershipHero = true;
      this.nextEvent = undefined;
    }

    if(this.nextEvent?.team1Name && this.nextEvent?.team2Name) {
      this.showEventName = false;
    } else {
      this.showEventName = true;
    }
  }

  countDownTimer(date:string) {
    let timeGame:any = new Date(date);
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;
    let timer:any;

    const showRemainingTime = () => {
      let timeNow:any = new Date();
      let distance:any = timeGame - timeNow;

      if (distance < 0) {
        clearInterval(timer);
        return;
      }

      let days:any = Math.floor(distance / day);
      let hours:any = Math.floor((distance % day) / hour);
      let minutes:any = Math.floor((distance % hour) / minute);
      let seconds:any = Math.floor((distance % minute) / second);

      if(environment.connId === '9' || environment.connId === '1009') {
        this.countDownTillEvent = days + 'd ' + hours + "h " + minutes + "m " + seconds + "s";
      } else if(environment.connId === '61') {
        this.countDownTillEvent = days + ' DANA : ' + hours + " SATI : " + minutes + " MINUTE ";
      } else if(environment.pageFolder === 'sport') {
        if(hours < 10) {
          hours = "0" + hours;
        }
        if(minutes < 10) {
          minutes = "0" + minutes;
        }
        this.countDownTillEvent = days + " : " + hours + " : " + minutes;
      }
    }

    showRemainingTime();
    timer = setInterval(showRemainingTime, 1000);
  }

  goToEventPage(connId:string, event:number, actionId: number, nextEvent: any) {
    let url = environment.redirectUrl + "/";
    let action;

    if(Number(actionId) === Number(ACTION_ID.EXCLUSIVE_SUBSCRIBER_TICKET) || Number(actionId) === Number(ACTION_ID.SUBSCRIBER_TICKET_OS)) {
      this.selectedEventEmit.emit(this.nextEvent);
      if(GlobalConstants.isAuth) {
        this.modalService.openModal(ModalNames.HomepageModal);
      } else {
        localStorage.setItem('selectedEvent', JSON.stringify(nextEvent));
        sessionStorage.setItem('openModal', `HomepageModal`);
        this.modalService.openModal(ModalNames.Login);
      }
      return;
    }

    this.nextEvent.actions.map((item:any) => {
      if(Number(item.id) === Number(ACTION_ID.NORMAL))  {
        action = ACTION_ID.NORMAL;
      } else if(Number(item.id) === Number(ACTION_ID.SUBSCRIBER_TICKET)) {
        action = ACTION_ID.SUBSCRIBER_TICKET;
      }
    });

    void this.Router.navigate([`event/${connId}/${event}/${action}/${nextEvent.hashedId}`]);
  }
}
